<template>
  <div class="box">
    <div class="wrap1">
      <div class="mod1">
        <span class="word1">实物清单</span>
        <img :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/编组 3.svg'" class="material-list-icon"/>
      </div>
      <span class="message">为了保证实验正常进行，请您尽快寄送实验所需物品</span>
      <div class="mod2">
        <div class="section1">
          <img :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/提示语.svg'" class="label3"/>
          <span class="word3" v-if="waitSendOutMaterialNumber === 0">您已寄出所有实物</span>
          <span class="word3" v-else>有{{ waitSendOutMaterialNumber }}个实物待寄出</span>
        </div>
      </div>
    </div>
    <div class="wrap2 flex-row">
      <div class="sample-block" style="margin-right: 11px;">
        <div class="wrap3 flex-row"  @click="createSampleDeliverySheet">
          <img class="sample-delivery-icon" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/新建送样单.svg'"/>
          <span class="sample-delivery-text">寄送实物</span>
        </div>
      </div>
      <div class="sample-block">
        <div class="wrap3 flex-row" @click="showSampleDeliverySheet">
          <img class="sample-delivery-icon" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/查看送样单.svg'"/>
          <span class="sample-delivery-text">寄送记录</span>
        </div>
      </div>
    </div>
    <div class="wrap4 flex-row">
      <span class="word5">实物清单</span>
      <span class="word6" @click="downloadAllInformationSheets">下载全部物品信息表</span>
    </div>
    <div v-for="(material,index) in orderMaterialInfo" :id="index" style="width:100%;" >
      <div class="wrap5" @click="queryMaterial(material)">
        <div class="bd4">
         <div class="mod4">
          <div style="margin-top: 5px">
            <display-icon-and-status :materialType = material.orderMaterial.materialType :displayType="emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_ICON"></display-icon-and-status>
          </div>
          <div class="group3 flex-col">
            <div class="group4 flex-row">
              <span class="word7">{{ material.orderMaterial.materialDesc }}</span>
              <display-icon-and-status :displayStatusName = material.displayStatusName :displayType="emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_NMAE"></display-icon-and-status>
            </div>
            <span class="txt2">用于{{ material.orderMaterial.euName }}</span>
          </div>
          <img class="right-icon" :src="emkt.MATERIAL_STATIC_FILE_BASE_URL + 'other/right.svg'"/>
        </div>
      </div>
    </div>
    </div>
    <div class="wrap6">
      <span class="txt8">点击可查看送样指南、</span>
      <span class="txt8" style="color: rgba(254, 101, 77, 1);">下载实物信息表</span>
      <span class="txt8">并查看送样记录</span>
    </div>
  </div>
</template>
<script>
import wx from 'wx'
import DisplayIconAndStatus from './DisplayIconAndStatus'
import { mapState, mapGetters, mapMutations } from 'vuex'
export default {
  name: 'SampleDeliveryList',
  components: {DisplayIconAndStatus},
  computed: {
    ...mapState(['sessionInfo']),
    ...mapGetters(['getOrderMaterialInfo']),
    waitSendOutMaterialNumber: function () {
      this.waitSendOutMaterial = 0
      this.orderMaterialInfo.forEach(material => {
        if (material.displayStatusName === '待寄出') {
          this.waitSendOutMaterial++
        }
      })
      return this.waitSendOutMaterial
    }
  },
  created () {
    this.fetchData()
  },
  data () {
    return {
      waitSendOutMaterial: 0,
      from: '',
      orderMaterialInfo: []
    }
  },
  activated () {
    this.fetchData()
  },
  methods: {
    ...mapMutations(['MATERIALDETAIL_ORDERMATERIALID']),
    fetchData () {
      this.gcapi('loadOrderMaterialInfo', this.getOrderMaterialInfo[0].orderMaterial.orderNo).then((res) => {
        if (res.body.result !== '[]') {
          this.orderMaterialInfo = JSON.parse(res.body.result)
        }
      })
    },
    queryMaterial (material) {
      this.MATERIALDETAIL_ORDERMATERIALID(material.orderMaterial.orderMaterialId)
      this.$router.push({
        name: 'MaterialDetail'
      })
    },
    createSampleDeliverySheet () {
      this.$router.push({
        name: 'MaterialSendProcess'
      })
    },
    showSampleDeliverySheet () {
      this.$weui.loading('加载中')
      let params = {json: this.orderMaterialInfo[0].orderMaterial.orderNo, method: 'loadOrderMaterialExpress'}
      this.gcapi('invokeBsmMethod', params).then((res) => {
        this.$router.push({
          name: 'MySampleDeliverySheet',
          params: {orderMaterialExpressList: JSON.parse(res.body.result)}
        })
        this.$weui.loading('加载中').hide()
      })
    },
    downloadAllInformationSheets () {
      wx.miniProgram.navigateTo({
        url:
          '/pages/file/downloadSampleInfoFile?customerNo=' +
          this.sessionInfo.customerInfo.customerNo +
          '&fileName=' +
          this.getOrderMaterialInfo[0].orderMaterial.orderNo + '-物品信息表.zip' +
          '&fileType=' +
          'zip' +
          '&orderNo=' +
          this.getOrderMaterialInfo[0].orderMaterial.orderNo
      })
    }
  }
}
</script>

<style scoped>
  .box {
    overflow-y:scroll;
    overflow-x:hidden;
    height:100vh;
    position: relative;
    padding-bottom: 0;
    background-color: rgba(250, 250, 250, 1);
    padding-top: 0;
  }

  .wrap1 {
    width: 100%;
    height: 130px;
    justify-content: flex-end;
    align-items: flex-start;
    position: relative;
    padding: 0 0 10px 25px;
    display: flex;
    flex-direction: column;
    background-color: #5878FA;
  }

  .mod1 {
    width: 78%;
    height: 120px;
    justify-content: space-between;
    display: flex;
  }

  .word1 {
    color: rgba(255, 255, 255, 1);
    font-size: 21px;
    font-family: PingFangSC-Medium;
    white-space: nowrap;
    line-height: 29px;
    margin-top: 6px;
  }

  .material-list-icon {
    width: 54%;
    height: 120px;
  }

  .message {
    position: absolute;
    top: 39px;
    color: rgba(255, 255, 255, 1);
    font-size: 14px;
    line-height: 20px;
  }

  .mod2 {
    height: 39px;
    border-radius: 10px;
    background-color: rgba(255, 255, 255, 1);
    width: 94%;
    justify-content: center;
    align-items: flex-start;
    padding-left: 15px;
    position: absolute;
    left: 10px;
    display: flex;
    flex-direction: column;
  }

  .section1 {
    width: 68%;
    height: 20px;
    justify-content: space-between;
    display: flex;
  }

  .label3 {
    width: 16px;
    height: 16px;
    margin-top: 2px;
  }

  .word3 {
    width: 236px;
    height: 20px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(88, 120, 250, 1);
    font-size: 14px;
    font-family: PingFangSC-Medium;
    white-space: nowrap;
    line-height: 20px;
    text-align: left;
    margin-left: 2px;
  }

  .wrap2 {
    width: 94%;
    height: 67px;
    justify-content: space-between;
    margin: 10px 10px 0 10px;
  }

  .sample-block {
    border-radius: 10px;
    border: 0.5px solid rgba(239, 238, 243, 1);
    background-color: rgba(255, 255, 255, 1);
    width: 55%;
    justify-content: center;
    padding-left: 14px;
    display: flex;
    flex-direction: column;
  }

  .wrap3 {
    width: 33%;
    height: 36px;
    justify-content: space-between;
  }

  .sample-delivery-text {
    color: rgba(66, 66, 66, 1);
    font-size: 15px;
    font-family: PingFangSC-Medium;
    white-space: nowrap;
    line-height: 21px;
    margin-top: 7px;
    margin-left: 15px;
  }

  .sample-delivery-icon {
    width: 34px;
    height: 35px;
  }

  .wrap4 {
    width: 86%;
    height: 21px;
    justify-content: space-between;
    margin: 15px 0 0 25px;
  }

  .word5 {
    z-index: 184;
    width: 69px;
    height: 20px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 14px;
    white-space: nowrap;
    line-height: 20px;
    text-align: left;
  }

  .word6 {
    z-index: 200;
    width: 172px;
    height: 19px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(88, 120, 250, 1);
    font-size: 12px;
    white-space: nowrap;
    line-height: 19px;
    text-align: right;
    margin-top: 2px;
  }

  .wrap5 {
    width: 95%;
    margin: 10px 0 0 10px;
  }

  .bd4 {
    height: 67px;
    border-radius: 10px;
    border: 0.5px solid rgba(239, 238, 243, 1);
    background-color: rgba(255, 255, 255, 1);
    width: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
  }

  .mod4 {
    width: 90%;
    height: 40px;
    position: relative;
    display: flex;
  }

  .group3 {
    width: 164px;
    height: 40px;
    margin-left: 10px;
  }

  .group4 {
    width: 92px;
    height: 21px;
    justify-content: space-between;
  }

  .word7 {
    height: 21px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(66, 66, 66, 1);
    font-size: 15px;
    font-family: PingFangSC-Medium;
    white-space: nowrap;
    line-height: 21px;
    text-align: left;
    margin-right: 5px;
  }

  .txt2 {
    width: 164px;
    height: 19px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(146, 146, 146, 1);
    font-size: 12px;
    white-space: nowrap;
    line-height: 19px;
    text-align: left;
  }

  .right-icon {
    width: 7px;
    height: 12px;
    top: 14px;
    right: -5px;
    position: absolute;
  }

  .wrap6 {
    width: 322px;
    height: 19px;
    overflow-wrap: break-word;
    text-align: left;
    white-space: nowrap;
    align-self: flex-start;
    font-size: 0;
    margin: 10px 0 68px 25px;
  }

  .txt8 {
    font-size: 12px;
    color: rgba(146, 146, 146, 1);
    line-height: 19px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// SampleDeliveryList.vue?6a490fbb